import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Vehicle } from '@quorum/models/xs-resource';

@Component({
  selector: 'svc-vehicle-match-card',
  templateUrl: './vehicle-match-card.component.html',
  styleUrls: ['./vehicle-match-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleMatchCardComponent implements OnInit {
  @Input() vehicle: Vehicle;
  @Input() selected: boolean;
  constructor() {}

  ngOnInit() {}
}
